/**
 * Tab Component
 *
 * @file tab.js
 */

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
  };

  const cookieTab = () => {
    document.querySelector('.apply-all').addEventListener('click', function() {
      document.querySelector('.cookie-policy').style.display = 'none';
    });
  };

  const init = () => {
    defaultTab();
    cookieTab();
  };

  return {
    init,
  };
})();

export default tabs;
